<template>
    <div class="admin-login-box">
        <!--后台的登录入口，只有登录，没有注册，也没有找回密码-->
        <!--只有门户一个用户入口，如果是管理员则跳转到管理中心，否则，跳转到首页/重定向的页面-->
        <!--如果是门户的登录，则有登录、注册、找回密码这些功能.-->
        <!--顶部内容-->
        <div class="admin-login-header-box">
            <div class="admin-login-header-center center">
                <div class="admin-login-logo">
                    超田伴成长管理中心｜登录
                </div>
            </div>
        </div>
        <!--中间内容-->
        <div class="admin-login-center-box">
            <div class="center login-center-box">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form label-position="right" label-width="100px" @keyup.enter.native="doLogin">
                            <el-form-item label="手机号" required>
                                <el-input v-model="user.account" placeholder="手机号"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" required>
                                <el-input type="password" v-model="originalPassword" placeholder="请输入密码"></el-input>
                            </el-form-item>
                            <el-form-item label="图灵码" :required="true">
                                <el-input v-model="loginInfo.verifyCode" placeholder="请输入图灵验证码"></el-input>
                                <img class="captcha-code" :src="captchaPath" @click="updateCaptcha">
                            </el-form-item>
                            <el-form-item class="login-button">
                                <el-button type="primary" @click="doLogin" size="medium">
                                    登 录
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!--底部内容-->
    </div>
</template>
<script>
    import * as api from '@/api/api'
    import {hex_md5} from "@/utils/md5";
    import http from '@/api/http';

    export default {
        data() {
            return {
                originalPassword: '',
                user: {
                    account: '',
                    password: '',
                },
                captchaPath: '',
                loginInfo: {
                    verifyCode: '',
                    captchaKey: ''
                },
            }
        },
        methods: {
            toastE(msg) {
                this.$message({
                    message: msg,
                    center: true,
                    type: 'error'
                });
            },
            updateCaptcha() {
                // 使用原始 axios 请求以确保能获取到所有响应头
                http.axiosInstance.get(api.baseUrl + '/sys/captcha_text?code=' + Math.random(), {
                    responseType: 'blob',
                    headers: {
                        'Accept': 'image/webp,image/apng,image/*,*/*;q=0.8'
                    }
                }).then(response => {
                    // 从响应头获取验证码标识 - 使用原始响应对象
                    const captchaKey = response.headers?.['l-c-i'] || response.headers?.['L-C-I'];
                    if (!captchaKey) {
                        console.error('未获取到验证码标识', response.headers);
                        this.$message.error('获取验证码失败，请刷新重试');
                        return;
                    }
                    this.loginInfo.captchaKey = captchaKey;

                    // 处理验证码图片
                    if (this.captchaPath) {
                        URL.revokeObjectURL(this.captchaPath);
                    }
                    this.captchaPath = URL.createObjectURL(response.data);
                }).catch(error => {
                    console.error('获取验证码失败:', error);
                    this.$message.error('获取验证码失败，请检查网络');
                    this.loginInfo.captchaKey = '';
                    this.captchaPath = '';
                });
            },
            doLogin() {
                //发起登录
                //检查数据
                if (this.user.userName === '') {
                    this.toastE('账号不可以为空.');
                    return;
                }

                if (this.originalPassword === '') {
                    this.toastE('密码不可以为空.');
                    return;
                }

                if (this.loginInfo.verifyCode === '') {
                    this.toastE('图灵验证码不可以为空.');
                    return;
                }

                if (!this.loginInfo.captchaKey) {
                    this.toastE('验证码已失效，请重新获取.');
                    return;
                }

                this.user.password = hex_md5(this.originalPassword);
                api.doLogin(this.loginInfo.verifyCode, this.loginInfo.captchaKey, this.user).then(result => {
                    if (result.code === api.SUCCESS_CODE) {
                        // 存储 token
                        this.$store.dispatch('login', result.data);

                        // 获取用户信息并处理
                        api.checkToken().then(userResult => {
                            if (userResult.code === api.LOGIN_SUCCESS) {
                                // 存储用户信息到 vuex
                                const userInfo = {
                                    avatar: userResult.data.avatar,
                                    roleId: userResult.data.roleId,
                                    userName: userResult.data.userName,
                                    userId: userResult.data.id,
                                    companyId: userResult.data.companyId,
                                    companyName: userResult.data.companyName
                                };
                                this.$store.dispatch('setUserInfo', userInfo);

                                // 显示成功消息
                                this.$message.success(result.msg);

                                // 确保状态更新后再跳转
                                this.$nextTick(() => {
                                    this.$router.replace('/');
                                });
                            } else {
                                this.$message.error('获取用户信息失败');
                                this.updateCaptcha();
                            }
                        }).catch(error => {
                            console.error('获取用户信息失败:', error);
                            this.$message.error('获取用户信息失败，请重试');
                            this.updateCaptcha();
                        });
                    } else {
                        this.$message.error(result.msg);
                        this.updateCaptcha();
                    }
                }).catch(error => {
                    console.error('登录失败:', error);
                    this.$message.error('登录失败，请检查网络');
                    this.updateCaptcha();
                });
            },
        },
        mounted() {
            this.updateCaptcha();
        }
    }
</script>
<style>
    .captcha-code {
        cursor: pointer;
        vertical-align: middle;
        margin-left: 10px;
        border: solid 1px #E6E6E6;
        width: 120px;
        padding-left: 10px;
        padding-right: 10px;
        height: 40px;
    }

    .login-button {
        margin-bottom: 0;
    }

    .admin-login-header-box {
        width: 100%;
        height: 46px;
        margin-bottom: 20px;
        background: dodgerblue;
    }

    .center {
        margin: 0 auto;
        width: 1140px;
    }

    .admin-login-header-center {
        line-height: 46px;
    }

    .login-center-box .el-input {
        width: 200px;
    }

    .login-center-box {
        border-radius: 4px;
        width: 1100px;
        padding: 20px;
        background: #fff;
        box-shadow: 0 1px 10px #afafaf;
    }

    .admin-login-logo {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
    }

    .login-center-box .el-input__inner {
        border: solid 1px #E6E6E6;
        height: 42px;
        border-radius: 0;
    }

    .login-center-box .el-form-item__label {
        background: #FBFBFB;
        border-left: solid 1px #E6E6E6;
        border-top: solid 1px #E6E6E6;
        border-bottom: solid 1px #E6E6E6;
        text-align: center;
    }
</style>
